export const apiVersion = {
    '1.1': {
        headers: { accept: 'application/json;version=1.1;' }
    }
};
